import { Timer, CurrencyCircleDollar, Handshake } from "@phosphor-icons/react";
import type { Icon } from "@phosphor-icons/react";
import { SectionArrow } from "./SectionArrow";
import { TOTAL_INTEGRATIONS } from "../../lib/integrations";

interface Pillar {
  icon: Icon;
  title: string;
  description: string;
}

const pillars: Pillar[] = [
  {
    icon: Timer,
    title: "Time",
    description:
      "Give your team the freedom to focus on what actually drives growth.",
  },
  {
    icon: CurrencyCircleDollar,
    title: "Honest Pricing",
    description:
      `Free to start. $49 to scale. ${TOTAL_INTEGRATIONS} integrations on every plan. No paywalls, just more clients as you grow.`,
  },
  {
    icon: Handshake,
    title: "Trust",
    description:
      "When your client opens that report, your name is on it. We take that seriously. Their trust in you depends on it, and our reputation depends on getting it right.",
  },
];

export function PillarsSection() {
  return (
    <div id="pillars" className="pt-8 pb-12 sm:pt-12 sm:pb-14 scroll-mt-20">
      {/* px-6 on mobile keeps the pillar cards off the screen edges; desktop sm:px-8. */}
      <div className="max-w-[1200px] mx-auto px-6 sm:px-8">
        <div className="text-center mb-12">
          <SectionArrow />
          <h2 className="text-2xl sm:text-3xl font-bold text-foreground">
            The 3 pillars ProvenLeap was built on
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {pillars.map((pillar) => (
            <div
              key={pillar.title}
              className="text-center px-6 py-4 bg-white shadow-xs rounded-[32px]"
              style={{ border: "0.5px solid var(--hairline)" }}
            >
              <div className="mb-4 flex justify-center">
                <pillar.icon size={22} className="text-foreground relative top-2" />
              </div>
              <h3 className="text-[19px] font-semibold text-foreground mb-2">
                {pillar.title}
              </h3>
              <p className="text-[16px] text-foreground/85 leading-relaxed">
                {pillar.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
